import { Product } from "../Catalog/Product"

export class DragInfo {
  constructor(
    public dModel?: Product,
    public dField?: string,
    public dSystem?: string,
    public dElement?: string,
    public dDisplayName?: string,
  ) {
    }
 

}
